
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import OrderRequestBill from "@/assets/js/Bill/OrderRequestBill";
import UserRequestBill from "@/assets/js/Bill/UserRequestBill";
import dialogCom from "@/components/ModelCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import AddrCom from "@/components/AddrCom.vue";
import BoxCom from "@/components/BoxCom.vue";
import PicsBox from "@/components/PicsBox.vue";
import cookie from "@/assets/js/CookieUtil";
import uploadPicCom from "@/components/UploadPicComs.vue";
import Vue from "vue";
import { cookieTypes } from "@/assets/js/Types";
export default Vue.extend({
  components: { BoxCom, AddrCom, PicsBox, dialogCom, uploadPicCom },
  data() {
    return {
      sid: "" as any,
      detail: {} as any,
      projectSid: "" as any,
      users: [] as any[],
      choosedItem: [] as any[],
      actionForm: {
        workOrderSid: "",
        processPics: "",
        analysis: "",
        processComplete: true,
        result: 1,
      } as any,
      ratForm: {
        rating: 10,
        workOrderSid: "",
      },
    };
  },
  async mounted() {
    this.sid = this.$route.query.sid;
    this.projectSid = cookie.getCookie(cookieTypes.XC_COOKIES_PROJECTSID);
    await this.getDetail();
    await this.getUserList();
  },
  methods: {
    async fpOrder() {
      this.choosedItem = [];
      const dialog: any = this.$refs.fpDialog;
      dialog.show();
    },
    closeRatDialog() {
      const dialog: any = this.$refs.ratDialog;
      dialog.hiden();
    },
    actionOrder() {
      const dialog: any = this.$refs.actionDialog;
      dialog.show();
    },
    closeActionDialog() {
      const dialog: any = this.$refs.actionDialog;
      dialog.hiden();
    },
    async checkOrder() {
      const dialog: any = this.$refs.ratDialog;
      dialog.show();
    },
    async onRatSubmit() {
      this.ratForm.workOrderSid = this.sid;
      await HttpUtil.XCHttpPost(Urls.ApproveWorkOrder, this.ratForm, true, false);
      await this.getDetail();
      this.closeActionDialog();
    },
    async onActionSubmit() {
      this.actionForm.workOrderSid = this.sid;
      const picCom: any = this.$refs.uploadPicCom;
      const pics = picCom.GetPics();

      this.actionForm.processPics = "";
      let picArray = [] as string[];
      if (pics && pics.length > 0) {
        pics.forEach((pic: any) => {
          console.log(pic);
          picArray.push(pic.url);
        });
      }
      const picString = JSON.stringify(picArray);
      this.actionForm.processPics = picString;
      await HttpUtil.XCHttpPost(Urls.ProcessWorkOrder, this.actionForm, true, false);
      await this.getDetail();
      this.closeActionDialog();
    },
    async onFPSubmit() {
      const data = {
        workOrderSids: [this.sid],
        userSids: this.choosedItem,
      };
      await HttpUtil.XCHttpPost(Urls.AllocationWorkOrder, data, true, false);
      await this.getDetail();
      this.closeDialog();
    },
    closeDialog() {
      const dialog: any = this.$refs.fpDialog;
      dialog.hiden();
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.sid);
      });
    },
    async confirmOrder() {
      await HttpUtil.XCHttpPost(
        Urls.ConfirmOrder,
        { workOrderSid: this.sid, confirm: true, reason: "" },
        true,
        false
      );
      await this.getDetail();
    },
    async getUserList() {
      const data = {
        page: 0,
        pageSize: 100,
        pagination: true,
        conditions: [
          {
            field: "projectSid",
            value: this.projectSid,
            conditionType: 0,
          },
        ],
      };
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetUsers, data, true, false);
      this.users = ret.data;
      console.log(this.users, ret, "testest");
    },
    async reciveOrder() {
      this.$confirm("确认是否接单", "提示", {
        confirmButtonText: "接单",
        cancelButtonText: "取消",
      }).then(() => {
        HttpUtil.XCHttpPost(Urls.TakeOnOrder, this.sid, true, false)
          .then(() => {
            this.getDetail();
          })
          .catch((err: any) => {
            this.$message.error(err);
          });
      });
    },
    async getDetail() {
      this.detail = await HttpUtil.XCHttpPost(Urls.GetOrder, this.sid, true, false);
      this.detail.reportPics = JSON.parse(this.detail.reportPics);
      this.detail.processPics = JSON.parse(this.detail.processPics);
      const addrCom: any = this.$refs.addrCom;
      addrCom.init({
        lat: this.detail.lat,
        lng: this.detail.lng,
        addr: this.detail.address,
      });
    },
  },
});
